import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

const TenantNotFoundPage = () => {
  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center px-4">
      <div className="max-w-xl w-full bg-white border border-neutral-200 rounded-xl shadow-sm p-8 text-center">
        <AlertTriangle className="w-12 h-12 text-amber-500 mx-auto mb-4" />
        <h1 className="text-2xl font-display font-bold text-neutral-900 mb-3">
          Tenant não encontrado
        </h1>
        <p className="text-neutral-600 mb-6">
          Não foi possível resolver o slug informado. Verifique a URL ou volte para a página inicial.
        </p>
        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-md bg-primary-600 px-4 py-2 text-white hover:bg-primary-700 transition-colors"
        >
          Voltar para a página inicial
        </Link>
      </div>
    </div>
  );
};

export default TenantNotFoundPage;
